import {Show} from 'platform/foundation';

import {ReactNode, useContext} from 'react';

import {FilterFieldsContext} from '../contexts/FilterFieldsContext';
import {FilterFieldName} from '../utils/getFilterSections';

export function FilterField(props: {name: FilterFieldName; children: ReactNode}) {
  const fields = useContext(FilterFieldsContext);
  return <Show when={fields === null || fields.includes(props.name)}>{props.children}</Show>;
}
